export default "__VITE_ASSET__DW6BDzjJ__"